const SCALE_FACTORS = {
    max: 64,
    min: 0.01,
    multiplier: 1.25,
    delta: 0.05,
};
// Fit scale is not included as a breakpoint if it is extremely close to another breakpoint
const MINIMUM_DISTANCE_FOR_FIT_SCALE = 0.02;
const sortArray = (array, ascend) => array ? array.sort((a, b) => (ascend ? a - b : b - a)) : [];
// Window overlaps breakpoint so determine whether next or nextNext should snap to meet the breakpoint
const considerSnapping = (breakpoint, next, nextNext) => Math.abs(breakpoint - next) < Math.abs(breakpoint - nextNext) ? breakpoint : next;
const constrainZoomToFactors = (next) => {
    const { min, max } = SCALE_FACTORS;
    return Math.min(Math.max(next, min), max);
};
// Originally this function supported custom breakpoints. I dropped that so now it's pretty simple. Just gives an
// array of [fitScaleFactor, 1] with sorting and doesn't include fitScaleFactor if that would be annoying.
const getBreakpoints = (ascend, fitScaleFactor) => {
    const breakpoints = [1];
    // "Fit to screen" scale is included as a breakpoint unless it is very close
    if (fitScaleFactor && Math.abs(1 - fitScaleFactor) > MINIMUM_DISTANCE_FOR_FIT_SCALE) {
        breakpoints.push(fitScaleFactor);
    }
    // We're sorting the breakpoints every time you click the zoom button. No need to stress about big O when `n` is 2.
    return sortArray(breakpoints, ascend);
};
const nextValue = (base, ascend) => {
    const { delta, multiplier } = SCALE_FACTORS;
    let next = base * (ascend ? multiplier : 1 / multiplier);
    if (delta) {
        // Round to multiplier of 5%
        next = Math.round(next / delta) * delta;
        // Ensure that the above rounding isn't just rounding us straight back to the original number
        if (Math.abs(next - base) < delta) {
            next += ascend ? delta : -delta;
        }
    }
    return constrainZoomToFactors(next);
};
/**
 * Determines the zoom factor that should be created as the result of a "zoom in" or "zoom out" action.
 * This may apply a delta and breakpoints to determine the zoom level that should be displayed.
 *
 * @param scaleFactor - current scale
 * @param ascend - zooming out or in?
 * @param previewType - preview type is used as some types have differing zoom behavior
 * @param fitScaleFactor - "fit to screen" scaling factor, if known
 * @return new scale factor
 */
export const zoom = ({ scaleFactor, ascend, fitScaleFactor }) => {
    // Special case handling for when you try to zoom with nothing set
    if (!scaleFactor) {
        return 1;
    }
    // Determine the BASE next value
    const next = nextValue(scaleFactor, ascend);
    // Prepare next-next value so we can identify the range of a 2x zoom action and determine whether snapping is needed
    const nextNext = nextValue(next, ascend);
    for (const breakpoint of getBreakpoints(ascend, fitScaleFactor)) {
        if (ascend) {
            if (scaleFactor < breakpoint && nextNext >= breakpoint) {
                return considerSnapping(breakpoint, next, nextNext);
            }
        }
        else {
            if (scaleFactor > breakpoint && nextNext <= breakpoint) {
                return considerSnapping(breakpoint, next, nextNext);
            }
        }
    }
    return next;
};
//# sourceMappingURL=zoom.preenvesnextjs.map
